import { Card, CardContent, CardHeader, Grid, Stack } from '@mui/material';
import { CpgRetailer } from '../../api/schema';
import { useState } from 'react';
import { SummaryCardTitle } from './SummaryCardTitle';
import { DonutChartWithTitle } from './DonutChartWithTitle';
import { ValueInput } from '@utils/formattersV2';
import {
  buildProjectedIncrementalSalesChartProps,
  buildTotalProjectedSalesChartProps,
} from '@features/campaigns/subdomains/cpg/domain/charts/donut-charts';
import { RetailersDataGrid, RetailersDataGridProps } from './RetailersDataGrid';
import { getSummaryRetailers } from '../../domain/summary-retailers';

type MinimalCpgRetailer = Pick<
  CpgRetailer,
  'name' | 'projectedIncrementalSales' | 'totalProjectedSales' | 'salesRate'
>;

export type SummaryCardProps = {
  retailers: (MinimalCpgRetailer &
    RetailersDataGridProps['retailers'][number])[];
  overallProjectedIncrementalSales: ValueInput;
  overallTotalProjectedSales: ValueInput;
};

export const SummaryCard = (props: SummaryCardProps) => {
  const [filterTopRetailers, setFilterTopRetailers] = useState(false);
  const filteredRetailers = getSummaryRetailers(
    props.retailers,
    filterTopRetailers
  );

  const projectedIncrementalSalesChartProps =
    buildProjectedIncrementalSalesChartProps(
      filteredRetailers,
      props.overallProjectedIncrementalSales
    );

  const totalProjectedSalesChartProps = buildTotalProjectedSalesChartProps(
    filteredRetailers,
    props.overallTotalProjectedSales
  );

  return (
    <Card>
      <CardHeader
        title={
          <SummaryCardTitle
            filterTopRetailers={filterTopRetailers}
            setFilterTopRetailers={setFilterTopRetailers}
          />
        }
      />
      <CardContent>
        <Stack direction="column" gap="1rem">
          <Grid container>
            <Grid
              data-testid="projected-incremental-sales-chart"
              size={{
                sm: 12,
                lg: 6,
              }}
            >
              <DonutChartWithTitle
                title="Projected Incremental Sales"
                chartTitleText={projectedIncrementalSalesChartProps.titleText}
                data={projectedIncrementalSalesChartProps.data}
              />
            </Grid>
            <Grid
              data-testid="total-projected-sales-chart"
              size={{
                sm: 12,
                lg: 6,
              }}
            >
              <DonutChartWithTitle
                title="Total Projected Sales"
                chartTitleText={totalProjectedSalesChartProps.titleText}
                data={totalProjectedSalesChartProps.data}
              />
            </Grid>
          </Grid>

          <RetailersDataGrid retailers={props.retailers} />
        </Stack>
      </CardContent>
    </Card>
  );
};
